import { useFormikContext } from 'formik';
import { useEffect , useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { BASE_PATH_API } from 'constants/env';
import { decodeStorage } from 'functions/storageBase64';
import styles from './styles.module.sass'

const InputPhone = ({ setDataForm }) => {

    const formik = useFormikContext()
    const [ valPhone, setValPhone ] = useState('')
    const [ existPhone, setExistPhone ] = useState(false)
    const [ responsePhoneValidate, setResponsePhoneValidate ] = useState()

    const userProfile = decodeStorage('profileData')
    const idSears = userProfile ? String(userProfile?.idClaro) : null


    const getValidatePhone = async () => {
        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table/phone-customer-id/${idSears}`);
            const data = await response.json();
            setResponsePhoneValidate(data)
        } catch (error) {
            console.error('Error fetching getEventTable data:', error);
        }
    }

    const changePhone = (event) => {
        const input = event
        const telephone = input.trim()
        const phoneRegex = /^\d+$/

        formik.handleChange(event);
        if (phoneRegex.test(telephone)) {
            if(String(telephone).length === 10){
                setValPhone(telephone)
                formik.setFieldValue('phone_customer', Number(telephone));
            }else if(String(telephone).length < 10){        
                formik.setFieldValue('phone_customer', null);
                setValPhone(telephone)
            }
        }else {
            formik.setFieldValue('phone_customer', null);
            setValPhone('');
        }
    }

    useEffect(() => {
        if(idSears){
            getValidatePhone()
        }
    }, []);

    useEffect(() => {
        if(responsePhoneValidate?.metadata?.http_status === 200){
            if(responsePhoneValidate?.data?.customer?.phone_customer !== 0){
                const celPhone = responsePhoneValidate?.data?.customer?.phone_customer
                setValPhone(celPhone)
                formik.setFieldValue('phone_customer', Number(celPhone));
            }else{
                setExistPhone(true)
            }
        }else if(responsePhoneValidate?.metadata?.http_status === 404){
            setExistPhone(true)
        }
    }, [responsePhoneValidate]);

    useEffect(() => {
       setDataForm(formik.values)
    }, [formik.values]);
  
  
    return(
        <section className={existPhone ? styles?.sectionPhone : `${styles?.sectionPhone} ${styles?.hiddenSection}`}>
            <Form>
                <div className={styles?.contFormPhone}>
                    <label htmlFor='phone'>
                    Teléfono celular:
                    </label>
                    <InputGroup hasValidation className='offset-1'>
                        <input 
                            type="tel" 
                            name="phone"
                            onChange={(e) => changePhone(e.target.value)}
                            value={valPhone}
                            placeholder="+01 5555555555"
                            className="inputBorder"
                            required
                        />
                    </InputGroup>
                </div>
            </Form>
        </section>
    )
  }

  export default InputPhone